import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../utils/api';

export const getAlertSupplierConfirmationunreadCountSlice = createApi(`GetAlertSupplierConfirmationunreadCountSlice`,"GET");

const GetAlertSupplierConfirmationunreadCountSlice = createSlice({
  name: 'GetAlertSupplierConfirmationunreadCountSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAlertSupplierConfirmationunreadCountSlice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAlertSupplierConfirmationunreadCountSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAlertSupplierConfirmationunreadCountSlice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default GetAlertSupplierConfirmationunreadCountSlice.reducer;